import axiosInstance from "../../axiosInstance";

/**
 * Get Editor list
 * @param {*} searchKey
 * @param {*} sortBy
 * @param {*} sortDirection
 * @param {*} page
 * @param {*} limit
 * @returns
 */
const getEditorList = async ({
  searchKey,
  sortBy,
  sortDirection,
  page,
  limit,
}) => {
  try {
    const res = await axiosInstance.get(
      `/api/editor/list?searchKey=${searchKey}&sortBy=${sortBy}&sortDirection=${sortDirection}&page=${page}&limit=${limit}`
    );

    if (res.status === 200) {
      return res.data;
    } else {
    }
  } catch (error) {}
};

export default getEditorList;
